import { v4 } from 'uuid'

/** Adds a unique id to any object  */
export const uuidObject = <T = any>(obj: T): T & { readonly id: string } => ({ ...obj, id: v4() })
